webpackJsonp([90179704293519],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(44);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryTemplateDetails = function (_React$Component) {
	  _inherits(CategoryTemplateDetails, _React$Component);
	
	  function CategoryTemplateDetails() {
	    _classCallCheck(this, CategoryTemplateDetails);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryTemplateDetails.prototype.render = function render() {
	    var items = [];
	    var category = this.props.pathContext.category;
	
	    var paper = this.props.data.allMarkdownRemark.edges;
	    paper.forEach(function (paper) {
	      items.push(_react2.default.createElement(_Paper2.default, { data: paper, key: paper.node.fields.slug }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'content__inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'page__title' },
	            category
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page__body' },
	            items
	          )
	        )
	      )
	    );
	  };
	
	  return CategoryTemplateDetails;
	}(_react2.default.Component);
	
	exports.default = CategoryTemplateDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Paper = function (_React$Component) {
	  _inherits(Paper, _React$Component);
	
	  function Paper() {
	    _classCallCheck(this, Paper);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Paper.prototype.render = function render() {
	    var _props$data$node$fron = this.props.data.node.frontmatter,
	        title = _props$data$node$fron.title,
	        date = _props$data$node$fron.date,
	        category = _props$data$node$fron.category,
	        status = _props$data$node$fron.status,
	        conference = _props$data$node$fron.conference,
	        conferenceLink = _props$data$node$fron.conferenceLink,
	        arxivLink = _props$data$node$fron.arxivLink,
	        slidesLink = _props$data$node$fron.slidesLink,
	        datasetsLink = _props$data$node$fron.datasetsLink,
	        videoLink = _props$data$node$fron.videoLink,
	        acmLink = _props$data$node$fron.acmLink,
	        pdfLink = _props$data$node$fron.pdfLink,
	        authors = _props$data$node$fron.authors,
	        description = _props$data$node$fron.description;
	    var _props$data$node$fiel = this.props.data.node.fields,
	        slug = _props$data$node$fiel.slug,
	        categorySlug = _props$data$node$fiel.categorySlug;
	
	
	    var conferenceBlurb = void 0;
	
	    var maybePrefix = function maybePrefix(link) {
	      // console.log("Link is " + link);
	      // console.log("Index of is " + link.indexOf('://'));
	      if (link.indexOf('://') !== -1) {
	        // console.log("  No prefix.");
	        return link;
	      } else {
	        // console.log("  With prefix.");
	        return (0, _gatsbyLink.withPrefix)(link);
	      }
	    };
	
	    var makeBlurb = function makeBlurb(name, link, nospace) {
	      if (link && link !== '#') {
	        if (nospace) {
	          return _react2.default.createElement(
	            'a',
	            { className: 'paper__linkout', href: maybePrefix(link) },
	            name
	          );
	        }
	        return _react2.default.createElement(
	          'a',
	          { className: 'paper__linkout paper__linkspace', href: maybePrefix(link) },
	          name
	        );
	      }
	      return undefined;
	    };
	
	    var pdfBlurb = makeBlurb('pdf', pdfLink, true);
	    var acmBlurb = makeBlurb('acm', acmLink);
	    var arxivBlurb = makeBlurb('arXiv', arxivLink);
	    var datasetsBlurb = makeBlurb('datasets', datasetsLink);
	    var slidesBlurb = makeBlurb('slides', slidesLink);
	    var videoBlurb = makeBlurb('video', videoLink);
	
	    var authorsBlock = _react2.default.createElement(
	      'span',
	      { className: 'paper__meta-authors' },
	      authors.map(function (author) {
	        return _react2.default.createElement(
	          'a',
	          { href: author.link, key: author.name },
	          author.name
	        );
	      })
	    );
	
	    if (status === 'To Appear At' || status === 'Published In') {
	      conferenceBlurb = _react2.default.createElement(
	        'a',
	        { href: conferenceLink, className: 'paper__meta-link' },
	        conference
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'paper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'paper__meta' },
	        _react2.default.createElement(
	          'span',
	          { className: 'paper__meta-status' },
	          status,
	          ' ',
	          conferenceBlurb
	        ),
	        _react2.default.createElement('span', { className: 'paper__meta-divider' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'paper__meta-category', key: categorySlug },
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: categorySlug, className: 'paper__meta-category-link' },
	              '#',
	              category
	            )
	          )
	        ),
	        _react2.default.createElement('hr', { className: 'paper__meta-hr' })
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'paper__title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'paper__title-link', to: slug },
	          title
	        )
	      ),
	      authorsBlock,
	      _react2.default.createElement(
	        'p',
	        { className: 'paper__description' },
	        description
	      ),
	      pdfBlurb,
	      acmBlurb,
	      arxivBlurb,
	      datasetsBlurb,
	      slidesBlurb,
	      videoBlurb
	    );
	  };
	
	  return Paper;
	}(_react2.default.Component);
	
	exports.default = Paper;
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Sidebar = __webpack_require__(24);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _CategoryTemplateDetails = __webpack_require__(217);
	
	var _CategoryTemplateDetails2 = _interopRequireDefault(_CategoryTemplateDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryTemplate = function (_React$Component) {
	  _inherits(CategoryTemplate, _React$Component);
	
	  function CategoryTemplate() {
	    _classCallCheck(this, CategoryTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryTemplate.prototype.render = function render() {
	    var title = this.props.data.site.siteMetadata.title;
	    var category = this.props.pathContext.category;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: category + ' - ' + title }),
	      _react2.default.createElement(_Sidebar2.default, this.props),
	      _react2.default.createElement(_CategoryTemplateDetails2.default, this.props)
	    );
	  };
	
	  return CategoryTemplate;
	}(_react2.default.Component);
	
	exports.default = CategoryTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-template-jsx-f7ca44f9a602f5077216.js